import * as React from 'react';
import classnames from 'classnames';
import { useSearch } from '@elastic/react-search-ui';

export default function SearchRoot({children}) {
  const { filters, searchTerm } = useSearch();

  const hasFilters = filters.length > 0;
  const hasQuery = Boolean(searchTerm?.trim());

  const rootClass = classnames({
    ['search-root']: true,
    ['search-root--with-filters']: hasFilters,
    ['search-root--with-query']: hasQuery,
  })

  return <div className={rootClass}>{children}</div>;
}
